import { Navigate, useLocation, useParams } from "react-router-dom";

import { legacyQuotePath } from "./legacy-quote-path";

export default function LegacyQuoteRedirect() {
  const { quoteId } = useParams<{ quoteId: string }>();
  const { search, hash } = useLocation();
  return <Navigate to={legacyQuotePath(quoteId, search, hash)} replace />;
}
